import { LIMPAR_MAPA_ITINERARIO_IDA } from '../types'

export default function limparMapaVeiculoItinerarioIda () {
  return {
    type: LIMPAR_MAPA_ITINERARIO_IDA
  }
}
